// extracted by mini-css-extract-plugin
module.exports = {"container":"TabView_container__rznwa","tab":"TabView_tab__pBpxT","active":"TabView_active__3mYib"};